import React  from "react";
import { AnimationFileLoader } from '../../../utilis/animation-loader'; // Adjust the path
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

function Register() {
    AnimationFileLoader();

  return (
    <>
      {/* Register */}
    <div className="py-5 d-flex align-items-center" style={{minHeight: "calc(100vh - 100px)"}}
        data-bg-img="/img/bg/page-bg2.png">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    {/* Card */}
                    <div className="card login-register-card">
                        <div className="card-body">
                            <div className="text-center mb-5">
                                <h2>Register New Account</h2>
                                <p>Already account yet? <NavLink to="login.html" className="c1">Login Now!</NavLink></p>
                            </div>

                            {/* Register Form */}
                            <form action="#">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="display_name" className="mb-2">Display name</label>
                                            <input type="text" id="display_name" className="form-control"
                                                placeholder="e.g@alex_anefty" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="email" className="mb-2">Email Address</label>
                                            <input type="email" id="email" className="form-control"
                                                placeholder="anefty@gmail.com" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="username" className="mb-2">Username</label>
                                            <input type="text" id="username" className="form-control"
                                                placeholder="e.g@alex_anefty" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="phone_num" className="mb-2">Phone Number</label>
                                            <input type="tel" id="phone_num" className="form-control"
                                                placeholder="+01 776-542154" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="password" className="mb-2">Password</label>
                                            <input type="password" id="password" className="form-control"
                                                placeholder="*** **** *** ****" />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="re-password" className="mb-2">Re-enter Password</label>
                                            <input type="password" id="re-password" className="form-control"
                                                placeholder="*** **** *** ****" />
                                        </div>
                                    </div>
                                    <div className="col-12 pt-2">
                                        <button type="submit" className="btn"><img src="/img/icons/btn-login.svg"
                                                alt="" className="svg"/> register now</button>
                                    </div>
                                </div>
                            </form>
                            {/* End Register Form */}
                        </div>
                    </div>
                    {/* End Card */}
                </div>
            </div>
        </div>
    </div>
    {/* End Register */}
    </>
  );
}

export default Register;
